import React from 'react';
import styled from 'styled-components';

import { Collapse } from 'antd';
import BlockItemHeader from './BlockItemHeader';
import BlockItemBody from './BlockItemBody';

const ListContainer = styled.div`
    max-height: 500px;
    overflow-y: scroll;
`;

const BlocksList = ({ blocks, currency }) => {
    const items = blocks.map((block) => ({
        key: block.code,
        label: <BlockItemHeader {...block} currency={currency} />,
        children: <BlockItemBody {...block} currency={currency} />,
    }));

    return (
        <ListContainer>
            <Collapse style={{ backgroundColor: 'inherit' }} bordered={false} items={items} />
        </ListContainer>
    );
};

export default BlocksList;
